import {useEffect, useState} from 'react'
import './App.css'
import axios from "axios";
import {Song} from "./Components/Song";
import {PlayList} from "./Components/PlayList";
import {Device} from "./Components/Device";
import {Album} from "./Components/Album";
import {Artist} from "./Components/Artist";
import CountdownTimer from './Clock';

function App() {
    const [token, setToken] = useState("");
    const [songlist, setSonglist] = useState<Song[]>([]);
    const [devices, setDevices] = useState<Device[]>([]);
    const [currentDeviceString, setCurrentDeviceString] = useState("");
    const [currentSong, setCurrentSong] = useState<Song>({id: "", name: "", album: {id: "", year: "", image: "", precision: ""}, artists: []});
    const [playlists, setPlaylists] = useState<PlayList[]>([]);
    const [currentPlaylist, setCurrentPlaylist] = useState<PlayList>({id: "", name: "", tracks: {href: "", total: 0}});
    const [flip, setFlip] = useState(false);
    const [playHistory, setPlayHistory] = useState<Song[]>([]);
    const [timeLeft, setTimeLeft] = useState<number>(0);

    const API_URL = "https://api.zegermouw.nl"

    const getDevices = async (access_token: string) => {
        const response = await axios.get("https://api.spotify.com/v1/me/player/devices", {
            headers: {
                'Authorization': `Bearer ${access_token}`,
            },
        });
        const devices = response.data.devices
        setDevices(devices)
    }
    const getPlaylists = async (access_token: string) => {
        const response = await axios.get("https://api.spotify.com/v1/search?q=hitster&type=playlist", {
            headers: {
                'Authorization': `Bearer ${access_token}`,
            }
        });
        setPlaylists(response.data["playlists"]["items"])
    }

    const getRandomSong = async() => {
        if(flip) {
            setFlip(false)
            setPlayHistory([...playHistory, currentSong])
        }
        const listLength = songlist.length
        const random_number = Math.floor(Math.random() * listLength)
        const random_song = songlist[random_number]["id"]
        const song = await axios.get(`https://api.spotify.com/v1/tracks/${random_song}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        await axios.put(`https://api.spotify.com/v1/me/player/play/?device_id=${currentDeviceString}`, {
            "uris": [`spotify:track:${random_song}`]
        }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        const artist_list: Artist[] = []
        for (let i = 0; i < song.data["artists"].length; i++) {
            artist_list.push({id: song.data["artists"][i]["id"], name: song.data["artists"][i]["name"]})
        }
        const a: Album = {id: song.data["album"]["id"], image: song.data["album"]["images"][0]["url"], year: song.data["album"]["release_date"], precision: song.data["album"]["release_date_precision"]}
        setCurrentSong({id: song.data["id"], name: song.data["name"], album: a, artists: artist_list})
        setTimeLeft(20);
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("access_token");
        if (token) {
            setToken(token);
            getDevices(token);
            getPlaylists(token);
        }
    }, []);

    const loginToSpotify = () => {
        window.location.href = API_URL + "/zegster/login";
    }

    const showLoginButton = () => {
       return <div>
            <button className="spotify-loginbutton" onClick={() => loginToSpotify()}>
                Login to Spotify
            </button>
        </div>
    }
    const handleDeviceClick = (device_id: string) => {
        setCurrentDeviceString(device_id)
    };
    const handlePlaylistClick = async (playlist: PlayList) => {
        setCurrentPlaylist(playlist)
        const list: Song[] = []
        let response = await axios.get(playlist.tracks.href, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.data["items"]) {
            for(let i = 0; i < response.data["items"].length; i++) {
                if (response.data["items"][i]["track"]) {
                    list.push({id: response.data["items"][i]["track"]["id"],name:  response.data["items"][i]["track"]["name"], album: response.data["items"][i]["track"]["album"]["images"][0]["url"], artists: response.data["items"][i]["track"]["artists"]})
                }
            }
        }
        while(response.data["next"]) {
            response = await axios.get(response.data["next"], {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.data["items"]) {
                for(let i = 0; i < response.data["items"].length; i++) {
                    if (response.data["items"][i]["track"]) {
                        list.push({id: response.data["items"][i]["track"]["id"], name: response.data["items"][i]["track"]["name"], album: response.data["items"][i]["track"]["album"]["images"][0]["url"], artists: response.data["items"][i]["track"]["artists"]})
                    }
                }
            }
        }
        setSonglist(list)
    }
    const showDevices = () => {
        if (devices.length === 0) return (
            <div></div>
        )
        return <div className="card-list">
            {devices.map((device: Device) => (
                <button key={device.id} className={"card " + (device.id === currentDeviceString ? 'selected' : 'not-selected')}
                        onClick={() => handleDeviceClick(device.id)}>
                    <h3>{device.name}</h3>
                </button>
            ))}
        </div>
    }
    const showPlaylists = () => {
        if (playlists.length === 0) return (
            <div></div>
        )
        let newPlaylists = playlists.filter((item) => item !== null);
        return <div className="scroll-container">
            <div className="scroll-content">
                {newPlaylists.map((item) => (
                    <button key={item.id} className={"scroll-item " + (item.id === currentPlaylist.id ? 'selected' : 'not-selected')} onClick={() => handlePlaylistClick(item)}>
                        {item.name}
                    </button>
                ))}
            </div>
        </div>
    }
    const getYearFromPrecision = (dateString: string, datePrecision: string) => {
        if (datePrecision === "year") return dateString
        if (datePrecision === "month") return dateString.split("-")[0]
        if (datePrecision === "day") return dateString.split("-")[0]
        else return dateString
    }
    const pauseSong = async () => {
        if (currentSong.id.length == 0) {
            return;
        }
        try {
        await axios.put(`https://api.spotify.com/v1/me/player/pause/?device_id=${currentDeviceString}`,{}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        } catch {

        }
    }
    const showFlipper = () =>  {
        if (currentSong.id.length === 0) return <div></div>
        else
            return <div className={"flip-container " + (flip ? "flip" : "")}>
                        <div className="flipper">
                            <div className="front">
                                <button className="revealbutton" onClick={() => setFlip(!flip)}>Reveal</button>
                            </div>
                            <div className="back">
                                <img
                                    src={currentSong.album.image}
                                    width="150px"
                                    height="150px"
                                    alt="Back"/>
                                <h3>{currentSong.name}</h3>
                                <h4>{currentSong.artists[0].name + " : " + getYearFromPrecision(currentSong.album.year, currentSong.album.precision)}</h4>
                            </div>
                        </div>
                    </div>

    }
    const playSongButton = () => {
        if (songlist.length > 0) return (
            <button className='spotify-loginbutton' onClick={() => getRandomSong()}>
            Play Song
        </button> )
    }
    const showHistory = () => {
        if (playHistory.length === 0) return <div></div>
        return <div className={"historycontainer"}> <div className="scroll-container">
            <div className="scroll-content">
                {playHistory.map((item) => (
                    <div key={item["id"]} className={"scroll-item"} onClick={() => setCurrentSong(item)}>
                        {item["name"] + "\n" + getYearFromPrecision(item.album.year, item.album.precision)}
                    </div>
                ))}
            </div>
        </div>
        </div>
    }
    if (token.length === 0) {
        return showLoginButton()
    } else {
        return (
            <>
                <div className={"container"}>
                    <h3>Select Device</h3>
                    {showDevices()}
                    <h3>Select Playlist</h3>
                    {showPlaylists()}
                    <div>
                        {playSongButton()}
                    </div>
                    <CountdownTimer timeLeft={timeLeft} setTimeLeft={setTimeLeft} pauseSong={pauseSong} />
                    {showFlipper()}
                    {showHistory()}
                </div>
            </>
        )
    }
}

export default App
